import React, { SVGProps } from 'react';

export function LockIconSimpleSmall({
  color = '#5D666D',
  width = 12,
  height = 12,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 12 12' fill='none' {...props}>
      <title>Lock Icon Simple Small</title>
      <g clipPath='url(#clip0_7763_10595)'>
        <path
          d='M3.50195 5.50052V3.50029C3.50195 2.83717 3.76535 2.20121 4.23419 1.73232C4.70303 1.26342 5.33891 1 6.00195 1C6.66499 1 7.30088 1.26342 7.76972 1.73232C8.23856 2.20121 8.50195 2.83717 8.50195 3.50029V5.50052M2.5 5.49902H9.5C10.0523 5.49902 10.5 5.94679 10.5 6.49914V9.99954C10.5 10.5519 10.0523 10.9997 9.5 10.9997H2.5C1.94772 10.9997 1.5 10.5519 1.5 9.99954V6.49914C1.5 5.94679 1.94772 5.49902 2.5 5.49902Z'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_7763_10595'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
